import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';

export const projectListActionTypes = {
  TOGGLE_SEARCH: type('[projects] Toggle Search Form'),
  QUICK_SEARCH: type('[projects] Quick Search'),
  SEARCH: type('[projects] Search'),
  CHANGE_PAGE_SIZE: type('[projects] Change Page Size'),
  PAGE_TO: type('[projects] Page To'),
  ORDER_BY: type('[projects] Order By'),
  LOAD: type('[projects] Load'),
  LOAD_SUCCESS: type('[projects] Load Success'),
  LOAD_FAIL: type('[projects] Load Fail'),
  SELECT_PAGE: type('[projects] Select Page'),
  UNSELECT_PAGE: type('[projects] Unselect Page'),
  TOGGLE_SELECTION: type('[projects] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[projects] Toggle Selection Tags'),
  CLEAR: type('[projects] Clear Data'),
  REMOVE: type('[projects] remove'),
  REMOVE_SUCCESS: type('[projects] remove Success'),
  REMOVE_FAIL: type('[projects] remove Fail'),
};


export class ToggleSearchProjectsAction implements Action {
  readonly type = projectListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchProjectsAction implements Action {
  readonly type = projectListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchProjectsAction implements Action {
  readonly type = projectListActionTypes.SEARCH;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class ChangeProjectsPageSizeAction implements Action {
  readonly type = projectListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageProjectsToAction implements Action {
  readonly type = projectListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderProjectsByAction implements Action {
  readonly type = projectListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadProjectsAction implements Action {
  readonly type = projectListActionTypes.LOAD;
  constructor() {}
}

export class LoadProjectsSuccessAction implements Action {
  readonly type = projectListActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: ArrayResponse<any>) {}
}

export class LoadProjectsFailAction implements Action {
  readonly type = projectListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectProjectsPageAction implements Action {
  readonly type = projectListActionTypes.SELECT_PAGE;
  constructor() {}
}

export class UnselectProjectsPageAction implements Action {
  readonly type = projectListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ToggleProjectsSelectionAction implements Action {
  readonly type = projectListActionTypes.TOGGLE_SELECTION;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class ClearProjectsAction implements Action {
  readonly type = projectListActionTypes.CLEAR;
  constructor() {}
}
export class RemoveProjectsAction implements Action {
  readonly type = projectListActionTypes.REMOVE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {
  }
}

export class RemoveProjectsSuccessAction implements Action {
  readonly type = projectListActionTypes.REMOVE_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: ArrayResponse<any>) {}
}

export class RemoveProjectsFailAction implements Action {
  readonly type = projectListActionTypes.REMOVE_FAIL;
  constructor(public payload?: string) {}
}
